import React from 'react';
import PropTypes from 'prop-types';

ColorPicker.propTypes = {
    options: PropTypes.arrayOf(PropTypes.string),
    selected: PropTypes.string,
    handleSelect: PropTypes.func,
    label: PropTypes.string,
    isRequired: PropTypes.bool,
    isDisabled: PropTypes.bool,
    gap: PropTypes.number,
};

function ColorPicker({
    options,
    selected,
    handleSelect,
    label,
    isRequired = false,
    isDisabled = false,
    gap = 8,
}) {
    const handleClick = (color) => {
        if (isDisabled) return;

        handleSelect(color);
    };

    return (
        <div className="flex flex-col" style={{ gap }}>
            {label && (
                <p className="font-body text-body-bold-s text-neutral-500">
                    {label} {isRequired && <sup className="text-red-500 leading-1">*</sup>}
                </p>
            )}
            <div className="flex flex-wrap gap-1 items-center">
                {options.map((color) => (
                    <div
                        key={color}
                        className={`w-[28px] min-w-[28px] h-[28px] rounded-[50%] flex justify-center items-center shadow-inset-2 transition-all ${
                            selected === color ? 'shadow-neutral-300' : 'shadow-transparent'
                        }`}
                        onClick={() => handleClick(color)}
                    >
                        <div
                            className="w-[20px] h-[20px] rounded-[50%]"
                            style={{
                                backgroundColor: color,
                                cursor: isDisabled ? 'default' : 'pointer',
                            }}
                        ></div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ColorPicker;
